import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 5,
  pageOptions: [3, 5, 10],
  totalRows: 1,
  sortOptions: [],
  fields: [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'icon', label: 'Icon'},
    { key: 'duration', label: 'duration'},
    { key: 'duration_unit', label: 'duration_unit'},
    { key: 'type', label: 'type'},
    { key: 'desc', label: 'Description'},
    { key: 'is_highlight', label: 'is highlight'},
    { key: 'created_at', label: 'Created At'},
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  items: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/legalservices/status/AC'}
    useIPA.get(param).then(response => {
      const service = {
        rows : response.data.data
      }
      commit('setData', {...service})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/legalservice/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        name: formData.text_1,
        icon: formData.text_2,
        desc: formData.text_3,
        is_highlight: formData.checkbox_4,
        type: formData.select_5,
        duration: parseInt(formData.text_6),
        duration_unit: formData.select_7
			}
      const param = { rawData: rawData, url: 'dashboard/master/legalservice', id: formData.id}
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'profession-service' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/legalservice', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, service) {
    state.items = service.rows
    state.totalRows = service.rows.length
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
